<template lang="html">

  <section class="las-catas">

    <div class="contenedor-titulo container">
      <h3 class="title -ghost">{{$t('vistas.las_catas')}}</h3>
    </div>

    <div class="contenedor-slider">

      <div class="slide">

        <slick ref="slick" :options="slickOptions" @beforeChange="handleBeforeChange" class="slider-catas">

          <div class="contenedor-imagen" v-for="e in 7">

            <span :data="e" class="imagen"></span>
            
          </div>

        </slick>

      </div>

    </div>

  </section>

</template>

<script lang="js">

  import Slick from 'vue-slick';

  export default  {
    name: 'las-catas',
    methods : {
     handleBeforeChange(event, slick, currentSlide, nextSlide) {
      this.active = nextSlide;
    },
  },
  data(){
    return {
      slickOptions: {
        slidesToShow: 4,
               responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
        ]
      },
      active : 0,
    }
  },
  components: { Slick }
}

</script>

<style scoped lang="scss">

@import "@/assets/css/colors.scss";

.las-catas {
  width: 100%;
  padding: 100px 0;
  background: $mud-brown;
}



.contenedor-imagen{
  width: 25vw;
  height: 25vw;
  display: block;
      .imagen{
      width: 100%;
      height: 100%;
      display: inline-block;
    }

    @for $i from 1 through 10{
      .imagen[data="#{$i}"]{
        background:url(/static/img/catas/#{$i}.jpg) center/cover no-repeat;
      }
    }
}

.contenedor-titulo{
  position: relative;

  .title{
    margin-bottom: 0;
    padding-bottom: 0;
    transform: translateY(-102px);
    opacity: 0;
    transition: 1s;
  }
}

.launched {

  .contenedor-titulo{
    .title{
      opacity: .5;
      transform: translateY(12px);
    }
  }

}

  @media screen and (max-width: 769px){
    .contenedor-imagen{
      height: 33.3333vw;
    }
    .title.-ghost{
      font-size: 34px;
      letter-spacing: 2px;
      
    }
    
    .las-catas{
      padding-top: 0;
    }

    .launched .contenedor-titulo .title{
      transform: translateY(8px);
    }

  }

  @media screen and (max-width: 600px){
    .las-catas{
      padding-top: 0px;
      padding-bottom: 50px;
      .title{
        margin-top: 30px;
        padding-bottom: 30px;
        font-size: 28px;
      }
    }
  }

  @media screen and (max-width: 480px){
    .contenedor-imagen{
      height: 50vw;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/views/experiencias/las-catas.vue